import "./ChangePass.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { UsersChangePassword } from "../../Api/Services";

function ChangePass() {
  const [inputValue, setInputValue] = useState({});
  const [flagLoading, setFlagLoading] = useState(false);

  const navigate = useNavigate();

  const LoginCheck = async () => {
    let validation = true;
    if (inputValue.oldPass === "") {
      toast.error("رمز عبور قبلی را وارد نمایید ");
      validation = false;
    }
    if (inputValue.newPass === "") {
      toast.error("  رمز عبور جدید  را وارد نمایید ");
      validation = false;
    }
    if (inputValue.newPass != inputValue.newPassRep) {
      toast.error("رمز عبور جدید مطابقت ندارد");
      validation = false;
    }
    if (validation) {
      setFlagLoading(true);
      try {
        const UsersChangePasswordData = await UsersChangePassword(inputValue);
        if (
          UsersChangePasswordData.status &&
          UsersChangePasswordData.status === 200
        ) {
          toast.success("رمز عبور جدید ثبت شد");
          localStorage.removeItem("Identity");
          localStorage.removeItem("Username");
          localStorage.removeItem("CompanyUserName");
          localStorage.removeItem("Token");

          navigate("/Login");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setFlagLoading(false);
      }
    }
  };
  const loginByEnter = (e) => {
    if (e.key === "Enter") {
      LoginCheck();
    }
  };

  return (
    <>
      {flagLoading && (
        <div
          className="scopeLoading d-flex justify-content-center align-items-center"
          style={{ height: window.innerHeight }}
        >
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={flagLoading ? "startLoading" : "stateLoading"}>
        <div className="d-flex justify-content-center align-items-center">
          <div id="loginForm">
            <h2 className="text-center w-100 mt-2">تغییر رمز عبور</h2>
            <div className="p-5" onKeyPress={loginByEnter}>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="password"
                  placeholder=" رمز عبور قبلی"
                  value={inputValue.oldPass}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      oldPass: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="password"
                  placeholder=" رمز عبور جدید"
                  value={inputValue.newPass}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      newPass: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="password"
                  placeholder=" تکرار رمز عبور جدید"
                  value={inputValue.newPassRep}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      newPassRep: e.target.value,
                    });
                  }}
                />
              </div>

              <div className="d-flex justify-content-center">
                <button className="loginButton mt-3" onClick={LoginCheck}>
                  ثبت
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePass;
